// Handle remote forms with with GET form requests.
$(document).on("submit", "form[method=get][data-turbo-get=true]", e=> {
  let params_string;
  e.preventDefault();
  const form = $(e.target);
  const params = form.serializeArray().filter(param => param["value"]);

  let url = form.attr("action");

  if (params_string = $.param(params)) {
    if (url.includes("?")) {
      url += `&${params_string}`;
    } else {
      url += `?${params_string}`;
    }
  }

  if (form.attr('target') == '_blank') {
    window.open(url, form.attr('target'), form.attr('rel'));
  } else {
    Turbo.visit(url, { action: form.data("turbo-action") || "advance" });
  }
});


// NOTE: `.activate-submit-on-change` class should be a parent element to the form(s)
// The event is binded to this parent element rather than the form itself so that the form
// can be replaced when returning JS from controller actions for form posts or updates. The
// event remains active since it's bound on the static parent element rather than the dynamic
// form that can be replaced in the DOM
$(document).on("turbo:load", () => {
  Array.from($(".activate-submit-on-change")).map((element) => new ActivateSubmitOnChange($(element)))
});

class ActivateSubmitOnChange {
  constructor(element) {
    this.init_change_watcher = this.init_change_watcher.bind(this);
    this.container = element;
    this.init_change_watcher();
  }

  init_change_watcher() {
    this.container.on("change input", "form input", e => {
      const input = e.currentTarget;

      if (input.required) {
        if (input.type == 'checkbox') {
          this.handle_form_changes($(input.form), input.checked);
        } else {
          this.handle_form_changes($(input.form), input.value.length > 0);
        }
      } else {
        this.handle_form_changes($(input.form), true);
      }
    });

    this.container.on("change", "form select", e => {
      this.handle_form_changes($(e.currentTarget.form), true);
    });
  }

  handle_form_changes(target, enabled) {
    let submit_button_target;
    let submit_button = undefined;

    if (submit_button_target = target.data("submit-button")) {
      submit_button = $(submit_button_target);
    } else {
      submit_button = target.find("input[type='submit']");
    }

    if (submit_button) {
      if (enabled) {
        submit_button.removeClass("disabled");
        submit_button.prop("disabled", false);
      } else {
        submit_button.addClass("disabled");
        submit_button.prop("disabled", true);
      }
    }
  }
}

$(document).on("turbo:load", () => {
  Array.from($(".password-field-with-requirements")).map((element) => new PasswordFieldWithRequirements($(element)))
});

class PasswordFieldWithRequirements {
  constructor(element) {
    this.init_change_watcher = this.init_change_watcher.bind(this);
    this.init_button_watcher = this.init_button_watcher.bind(this);
    this.validate_password_criteria = this.validate_password_criteria.bind(this);
    this.container = element;
    this.init_change_watcher();
    this.init_button_watcher();
  }

  init_change_watcher() {
    this.container.on("change input", "input", this.validate_password_criteria);
  }

  validate_password_criteria() {
    if (!this.container.find('.password-requirements').length) {
      return;
    }

    const input = this.container.find("input");

    const minLength = this.container.find(".password-requirements-length");
    const minLengthMet = input.val().length >= minLength.data("min-value");
    minLength.toggleClass("criteria-met", minLengthMet);

    const minSpecial = this.container.find(".password-requirements-special");
    const minSpecialMet = (input.val().match(/[\W\d]/g) || []).length >= minSpecial.data("min-value");
    minSpecial.toggleClass("criteria-met", minSpecialMet);

    const minUpper = this.container.find(".password-requirements-upper");
    const minUpperMet = (input.val().match(/\p{Lu}/gu) || []).length >= minUpper.data("min-value");
    minUpper.toggleClass("criteria-met", minUpperMet);
  }

  init_button_watcher() {
    const errorWrapper = this.container.find(".field_with_errors");
    if (errorWrapper.length > 0) {
      this.container.find(".password-show-hide").detach().appendTo(errorWrapper);
    }

    this.container.on("click", "button.password-show-hide", e => {
      const input = this.container.find("input[type=text], input[type=password]");

      if (input.attr("type") == "password") {
        input.attr("type", "text");
      } else {
        input.attr("type", "password");
      }
    })
  }
}
